import PropTypes from 'prop-types'
import { View } from './View'

/**
 * IBA独自コンポーネントです
 */
export const Link = ({ ...props }) => {
    return <View {...props} />
}

Link.propTypes = {
    /**
     * リンク表示テキスト
     */
    label: PropTypes.node,
    /**
     * 遷移先URL
     */
    href: PropTypes.string,
    /**
     * target属性
     */
    target: PropTypes.oneOf(['_blank']),
    /**
     * テキストフォントサイズ
     */
    fontSize: PropTypes.number,
    /**
     * ボーダーで囲う場合は true
     */
    isBorder: PropTypes.bool,
    /**
     * スタイル変更用のクラス名
     */
    className: PropTypes.any
}

Link.defaultProps = {
    fontSize: 14
}
